export class LoginModel {
  userName!: string;
  password!: string;
}
export enum AdminUserLoginRedirectEnum {
  Dashboard = 'Dashboard',
  Profile = 'Profile'
}
